module.exports = __webpack_public_path__ + "img/button-sprite.bc100b3b.svg";